import { SegmentedControl } from '@components/ui';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';

interface MobileBarProps {
  userId: string;
  activeKey?: string;
}

const MobileBar: React.FunctionComponent<MobileBarProps> = ({ userId, activeKey }) => {
  const theme = useTheme();
  const history = useHistory();

  return (
    <div style={{ background: theme.color.surface.baseline, padding: 16 }}>
      <SegmentedControl
        value={activeKey}
        options={[
          { key: 'life-id', label: 'Life-id', value: 'life-id' },
          { key: 'communication', label: 'Komunikácia', value: 'communication' },
        ]}
        onChange={(value) => {
          history.push(`/${value}/${userId}`);
        }}
      />
    </div>
  );
};

export default MobileBar;
